<template>
  <div class="hora">
    <div
      v-if="!isLoading && loadData"
      class="show container"
      style="font-family: IRANSansX-Regular">

      <div
        class="row justify-content-md-center"
        style="direction: ltr">
        <div
          ref="chart_box"
          class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0 p-lg-1">
          <div
            v-if="loadData['bhava'] && loadData['graha']"
            id="accordionExample3"
            class="accordion mr-auto mx-auto"
          >
            <div class="accordion-item">
              <h3
                id="headingTwo3"
                class="accordion-header">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo3"
                  aria-expanded="false"
                  aria-controls="collapseTwo3"
                >
                  D1 - Rashi Chart
                </button>
              </h3>
              <div
                id="collapseTwo3"
                class="accordion-collapse show"
                aria-labelledby="headingTwo3"
                data-bs-parent="#accordionExample3"
              >
                <div class="accordion-body p-0">
                  <keep-alive>
                    <Chart
                      v-if="loadData['bhava'] && loadData['graha']"
                      :varga_number="'D1'"
                      :varga_name="'Rasi'"
                      :bhavas="loadData['bhava']"
                      :grahas="loadData['graha']"
                      :show_degree="true"
                      :is_main_chart="true"
                      class="mr-auto mx-auto"
                    />
                  </keep-alive>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="showD1 && loadData['user']"
          class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0 p-lg-1"
        >
          <div
            v-if="loadData['bhava'] && loadData['graha']"
            id="accordionExample4"
            class="accordion mr-auto mx-auto"
          >
            <div class="accordion-item">
              <h3
                id="headingTwo4"
                class="accordion-header">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo4"
                  aria-expanded="false"
                  aria-controls="collapseTwo4"
                  v-text="chart2Text"
                />
              </h3>
              <div
                id="collapseTwo4"
                class="accordion-collapse show"
                aria-labelledby="headingTwo4"
                data-bs-parent="#accordionExample4"
              >
                <div class="accordion-body p-0">
                  <keep-alive>
                    <Chart
                      v-if="loadData['varga']"
                      :varga_number="'D9'"
                      :varga_name="'Navamsa'"
                      :bhavas="loadData['varga'][this.chart2Varga]['bhava']"
                      :grahas="loadData['varga'][this.chart2Varga]['graha']"
                      :show_degree="false"
                      :is_main_chart="false"
                      class="mr-auto mx-auto"
                    />
                  </keep-alive>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LoadingReport
      v-else
      :is-loading="isLoading" />
  </div>
</template>

<script>
import Chart from '../components/Chart.vue'
import ChartInfoFree from '../components/ChartInfoFree.vue'
import ChartAnalysisFree from '../components/ChartAnalysisFree.vue'
import ShareLinkFree from '../components/ShareLinkFree.vue'
import PlanetryTableFree from '../components/PlanetryTableFree.vue'
import DashaTable from '../components/DashaTable.vue'
import HelperLib from '../components/helper'
import HoraLogo from '../components/HoraLogo.vue'
import NoteListPro from '../components/NoteListPro.vue'
import ApiService from '../service/api'
import LoadingReport from '../components/LoadingReport.vue'

export default {
  name: 'D1D9',
  components: {
    Chart,
    ChartInfoFree,
    ChartAnalysisFree,
    PlanetryTableFree,
    DashaTable,
    HelperLib,
    HoraLogo,
    ShareLinkFree,
    NoteListPro,
    ApiService,
    LoadingReport
  },
  data () {
    return {
      isLoading: true,
      showD1 : '',
      chart2Varga: 'D9',
      chart3Varga: 'D30',
      chart2Text: 'D9 - Navamsa Chart',
      chart3Text: 'D30 - Trimshamsha',
      link_clicked: false,
      loadData: [],
      box_width: null,
      main_box_width: null,
      pages: {
        is_calculate: true,
        is_charts: false,
        is_notes: false
      }
    }
  },
  watch: {
    loadData: function (data) {
      this.loadData = data
    }
  },
  mounted: function () {
    // this.adjustBoxesWidth();
  },
  created () {
    let inputElement = document.getElementsByName('share2_id')[0];
    let id = document.getElementsByName('share2_id')[0]['value']
    let dataTypeValue = inputElement.getAttribute('data-type');
    dataTypeValue && dataTypeValue === "pro" ? this.showD1 = true : this.showD1 = false;
    this.isLoading = true
    ApiService.getReportChart_tal(id).then((response) => {
      this.isLoading = false
      this.loadData = response['data']
    })
  },
  methods: {
    adjustBoxesWidth () {
      if (screen.width > 960) {
        // DESKTOP
        this.box_width = (this.$refs.chart_box.clientWidth * 92) / 100
        this.main_box_width = (this.$refs.chart_box.clientWidth * 97) / 100
      } else {
        this.box_width = (this.$refs.chart_box.clientWidth * 100) / 100
        this.main_box_width = this.box_width
      }
    },
    isMobile () {
      return HelperLib.isMobile()
    },
    showMobileViewChartHeader (width) {
      return `
      font-size: 12px;
      border-radius: 8px;
      width: ${width}px;
      line-height: 10px;
      color: #000;`
    },
    formatLocation (user) {
      let lonDir = user['longitude'] < 0 ? 'W' : 'E'
      let latDir = user['latitude'] < 0 ? 'S' : 'N'
      let out =
        user['latitude_dms']['deg'] +
        ' ' +
        latDir +
        ' ' +
        user['latitude_dms']['min'] +
        ' - '
      out +=
        user['longitude_dms']['deg'] + ' ' + lonDir + ' ' + user['longitude_dms']['min']
      return out
    },
    formatLagnaText (rashi) {
      return HelperLib.rashiToPersianText(rashi)
    },
    getSignLink (data) {
      var lagna = HelperLib.rashiToPersianText(data['lagna']['Lg']['rashi'])
      return `${lagna[1]}`
    },
    updateLoadedData (data) {
      this.loadData = data
      // this.$chartNoteListRef.getList();
    },
    updateShowAnalysisOption (data) {
      this.show_analysis = data
    }
  }
}
</script>

<style scoped>
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
.custom-accordion-header {
  background-color: #f2f2f2;
  color: #333;
  border: 1px solid #ccc;
}

.custom-accordion-header:hover {
  background-color: #e6e6e6;
}

.custom-accordion-header.active {
  background-color: #ddd;
}
.accordion-button-custom:not(.collapsed) {
  color: #000000;
  font-weight: bold;
  background-color: #fff;
}

* {
  padding: 0px;
  margin: 0px;
}
.now-analysis {
  direction: rtl;
  text-align: right;
  background-color: rgba(255, 253, 231, 0.5);
  border-radius: 0.25rem;
  font-size: 16px;
  color: black;
  border: 1px solid rgb(242, 242, 242);
}
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
</style>
